import React from 'react';
import { Dialog } from 'primereact/dialog';
import closeIcon from '../assets/icons/closeIcon.svg';
import useWindowSize from '../hooks/useWindowSize';

function BottomPopup({
  visible, handleCloseModal, children, header, footer,
}) {
  const { width } = useWindowSize();
  return (
    <Dialog
      footer={footer || null}
      dismissableMask
      closeOnEscape
      closeIcon={() => <img src={closeIcon} alt="close icon" />}
      draggable={false}
      position={width < 768 ? 'bottom' : 'center'}
      header={header}
      headerClassName="bottom-popup-header"
      className="bottom-popup"
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.60)',
        width: '100%',
      }}
      visible={visible}
      onHide={() => { if (!visible) return; handleCloseModal(); }}
    >
      {children}
    </Dialog>
  );
}

export default BottomPopup;
